import { EventCatalogFromKeys, EventType } from "../types";

export const OrgEventKeys = {
  ORG_ACTION_CANCEL: "org-action-cancel",
  ORG_AREA_PAGE_VIEW: "org-area-page-view",
  ORG_AREAS_PAGE_VIEW: "org-areas-page-view",
  ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_ATTEMPT:
    "org-case-worker-registration-form-submit-attempt",
  ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_FAILURE:
    "org-case-worker-registration-form-submit-failure",
  ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_SUCCESS:
    "org-case-worker-registration-form-submit-success",
  ORG_CASE_WORKER_REGISTRATION_PAGE_VIEW:
    "org-case-worker-registration-page-view",
  ORG_CREATE_STORY_PAGE_VIEW: "org-create-story-page-view",
  ORG_HOMEPAGE_VIEW: "org-homepage-view",
  ORG_NEED_CARD_CLICK: "org-need-card-click",
  ORG_NEED_CLAIM_DELIVERED: "org-need-claim-completed",

  ORG_NEED_CLAIM_FAILURE: "org-need-claim-failure",

  ORG_NEED_CLAIM_PAGE_VIEW: "org-need-claim-page-view",

  // Multi-claim events
  ORG_NEED_CLAIM_SUBMIT: "org-need-claim-submit",

  ORG_NEED_CLAIM_SUCCESS: "org-need-claim-success",

  ORG_NEED_CLAIM_VERIFICATION_ERROR: "org-need-claim-verification-error",

  ORG_NEED_CLAIM_VERIFICATION_SUCCESS: "org-need-claim-verification-success",

  ORG_NEED_CLAIMED_PAGE_VIEW: "org-need-claimed-page-view",

  ORG_NEED_FILTER_APPLY: "org-need-filter-apply",

  ORG_NEED_NOT_FOUND_PAGE_VIEW: "org-need-not-found-page-view",

  ORG_NEED_PAGE_VIEW: "org-need-page-view",

  ORG_NEED_PAGINATION_CHANGE: "org-need-pagination-change",

  ORG_NEED_STORY_PAGE_VIEW: "org-need-story-page-view",

  ORG_NEED_UNCLAIM: "org-need-unclaim",

  ORG_NEEDS_PAGE_VIEW: "org-needs-page-view",

  ORG_STORIES_PAGE_VIEW: "org-stories-page-view",

  ORG_STORY_CARD_CLICK: "org-story-card-click",
  ORG_STORY_FORM_SUBMIT_ATTEMPT: "org-story-form-submit-attempt",
  ORG_STORY_FORM_SUBMIT_FAILURE: "org-story-form-submit-failure",
  ORG_STORY_FORM_SUBMIT_SUCCESS: "org-story-form-submit-success",
  ORG_VOLUNTEER_PAGE_VIEW: "org-volunteer-page-view",
} as const;

export const OrgEventCatalog: EventCatalogFromKeys<typeof OrgEventKeys> = {
  [OrgEventKeys.ORG_AREA_PAGE_VIEW]: {
    description: "Organization user viewed the area page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_AREA_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_ACTION_CANCEL]: {
    description: "Org user cancelled an action",
    eventType: EventType.INTERACTION,
    id: OrgEventKeys.ORG_ACTION_CANCEL,
  },

  [OrgEventKeys.ORG_AREAS_PAGE_VIEW]: {
    description: "Organization user viewed the areas page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_AREAS_PAGE_VIEW,
  },

  [OrgEventKeys.ORG_HOMEPAGE_VIEW]: {
    description: "Organization user viewed the homepage",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_HOMEPAGE_VIEW,
  },
  [OrgEventKeys.ORG_NEED_CARD_CLICK]: {
    description: "Organization user clicked a need card",
    eventType: EventType.BUTTON_CLICK,
    id: OrgEventKeys.ORG_NEED_CARD_CLICK,
  },
  [OrgEventKeys.ORG_NEED_FILTER_APPLY]: {
    description: "Org user applied a filter to needs",
    eventType: EventType.FILTER,
    id: OrgEventKeys.ORG_NEED_FILTER_APPLY,
  },
  [OrgEventKeys.ORG_NEED_PAGINATION_CHANGE]: {
    description: "Org user changed pagination in the needs list",
    eventType: EventType.INTERACTION,
    id: OrgEventKeys.ORG_NEED_PAGINATION_CHANGE,
  },
  [OrgEventKeys.ORG_NEEDS_PAGE_VIEW]: {
    description: "Organization user viewed the needs page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_NEEDS_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_STORIES_PAGE_VIEW]: {
    description: "Organization user viewed the stories page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_STORIES_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_STORY_CARD_CLICK]: {
    description: "Organization user clicked a story card",
    eventType: EventType.BUTTON_CLICK,
    id: OrgEventKeys.ORG_STORY_CARD_CLICK,
  },
  [OrgEventKeys.ORG_VOLUNTEER_PAGE_VIEW]: {
    description: "Organization user viewed the volunteer page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_VOLUNTEER_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_ATTEMPT]: {
    description:
      "Organization user attempted to submit the case worker registration form",
    eventType: EventType.FORM_SUBMISSION,
    id: OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_ATTEMPT,
  },
  [OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_FAILURE]: {
    description:
      "Organization user failed to submit the case worker registration form",
    eventType: EventType.ERROR,
    id: OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_FAILURE,
  },
  [OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_SUCCESS]: {
    description:
      "Organization user successfully submitted the case worker registration form",
    eventType: EventType.FORM_SUBMISSION,
    id: OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_FORM_SUBMIT_SUCCESS,
  },
  [OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_PAGE_VIEW]: {
    description: "Organization user viewed the case worker registration page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_CASE_WORKER_REGISTRATION_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_CREATE_STORY_PAGE_VIEW]: {
    description: "Organization user viewed the create story page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_CREATE_STORY_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_NEED_CLAIM_PAGE_VIEW]: {
    description: "Organization user viewed the need claim page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_NEED_CLAIM_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_NEED_CLAIM_VERIFICATION_ERROR]: {
    description:
      "Organization user encountered an error during need claim verification",
    eventType: EventType.ERROR,
    id: OrgEventKeys.ORG_NEED_CLAIM_VERIFICATION_ERROR,
  },
  [OrgEventKeys.ORG_NEED_CLAIM_VERIFICATION_SUCCESS]: {
    description: "Organization user successfully verified need claim",
    eventType: EventType.INTERACTION,
    id: OrgEventKeys.ORG_NEED_CLAIM_VERIFICATION_SUCCESS,
  },
  [OrgEventKeys.ORG_NEED_CLAIMED_PAGE_VIEW]: {
    description: "Organization user viewed the need claimed page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_NEED_CLAIMED_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_NEED_NOT_FOUND_PAGE_VIEW]: {
    description: "Organization user viewed the need not found page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_NEED_NOT_FOUND_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_NEED_PAGE_VIEW]: {
    description: "Organization user viewed a specific need page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_NEED_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_NEED_STORY_PAGE_VIEW]: {
    description: "Organization user viewed the need story page",
    eventType: EventType.PAGE_VIEW,
    id: OrgEventKeys.ORG_NEED_STORY_PAGE_VIEW,
  },
  [OrgEventKeys.ORG_STORY_FORM_SUBMIT_ATTEMPT]: {
    description: "Organization user attempted to submit the story form",
    eventType: EventType.FORM_SUBMISSION,
    id: OrgEventKeys.ORG_STORY_FORM_SUBMIT_ATTEMPT,
  },
  [OrgEventKeys.ORG_STORY_FORM_SUBMIT_FAILURE]: {
    description: "Organization user failed to submit the story form",
    eventType: EventType.ERROR,
    id: OrgEventKeys.ORG_STORY_FORM_SUBMIT_FAILURE,
  },
  [OrgEventKeys.ORG_STORY_FORM_SUBMIT_SUCCESS]: {
    description: "Organization user successfully submitted the story form",
    eventType: EventType.FORM_SUBMISSION,
    id: OrgEventKeys.ORG_STORY_FORM_SUBMIT_SUCCESS,
  },
  // Multi-claim events
  [OrgEventKeys.ORG_NEED_CLAIM_SUBMIT]: {
    description: "Organization user submitted a need claim",
    eventType: EventType.FORM_SUBMISSION,
    id: OrgEventKeys.ORG_NEED_CLAIM_SUBMIT,
  },
  [OrgEventKeys.ORG_NEED_CLAIM_SUCCESS]: {
    description: "Organization user successfully claimed a need",
    eventType: EventType.INTERACTION,
    id: OrgEventKeys.ORG_NEED_CLAIM_SUCCESS,
  },
  [OrgEventKeys.ORG_NEED_CLAIM_FAILURE]: {
    description: "Organization user failed to claim a need",
    eventType: EventType.ERROR,
    id: OrgEventKeys.ORG_NEED_CLAIM_FAILURE,
  },
  [OrgEventKeys.ORG_NEED_UNCLAIM]: {
    description: "Organization user unclaimed a need",
    eventType: EventType.INTERACTION,
    id: OrgEventKeys.ORG_NEED_UNCLAIM,
  },
  [OrgEventKeys.ORG_NEED_CLAIM_DELIVERED]: {
    description: "Organization user marked a claim as completed",
    eventType: EventType.INTERACTION,
    id: OrgEventKeys.ORG_NEED_CLAIM_DELIVERED,
  },
};
